<template>
    <div class="soft-competences-empty-wrapper">
        <router-link
            class="empty-btn"
            :to="{ name: 'competences' }"
        >Перейти в каталог</router-link>
        <div class="empty-icon"></div>
    </div>
</template>

<script>
export default {
    name: 'SoftCompetencesEmpty',
};
</script>

<style lang="scss" scoped>
    .soft-competences-empty-wrapper{
        display: flex;
        flex-direction: column;
        align-items: stretch;

        .empty-btn{
            background: #4663AB;
            border-radius: 4px;
            font-style: normal;
            font-weight: bold;
            font-size: 18px;
            line-height: 26px;
            color: #FFFFFF;
            width: 280px;
            height: 48px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }
        .empty-icon{
            height: 260px;
            background-size: 70% 70%;
            background-image: url("../../../../../../assets/images/account-track/empty-soft-competences.svg");
            background-repeat: no-repeat;
            background-position: 30% center;
        }
    }

</style>